module.exports = __webpack_public_path__ + "img/counter-icon-3.c0c81b30.svg";